<template>
  <header class="site-header">
    <div class="header-inner">
      <router-link to="/" class="brand" aria-label="White Pearl Ink – Startseite">
        <img :src="logo" width="62" height="46" alt="" />
        <span class="brand-name">white pearl ink<span>TATTOOS & SOUL ART</span></span>
      </router-link>
      <nav class="desktop-nav" aria-label="Hauptnavigation">
        <router-link v-for="item in links" :key="item.to" :to="item.to">{{
          item.label
        }}</router-link>
      </nav>
      <router-link to="/anfrage" class="button button-primary header-cta"
        >Tattoo anfragen <InkIcon name="diagonal"
      /></router-link>
      <button
        class="icon-button menu-toggle"
        aria-label="Menü öffnen"
        :aria-expanded="menuOpen"
        aria-controls="mobile-menu"
        @click="menuOpen = true"
      >
        <InkIcon name="menu" />
      </button>
    </div>
  </header>
  <NavigationDrawer :open="menuOpen" @close="menuOpen = false" />
  <nav
    v-if="route.path !== '/anfrage' && !route.path.startsWith('/admin')"
    class="mobile-dock"
    aria-label="Schnellnavigation"
  >
    <router-link to="/" exact-active-class="dock-active"
      ><InkIcon name="home" /><span>Entdecken</span></router-link
    >
    <router-link to="/tattoos" active-class="dock-active"
      ><InkIcon /><span>Tattoos</span></router-link
    >
    <router-link to="/art" active-class="dock-active" :class="{ 'dock-active': artPage }"
      ><InkIcon name="art" /><span>Kunst</span></router-link
    >
    <a
      v-if="artPage"
      href="mailto:rebecca.sophiaa.p@gmail.com?subject=Anfrage%20Auftragskunst"
      class="dock-cta"
      ><InkIcon name="diagonal" /><span>Kunst anfragen</span></a
    >
    <router-link v-else to="/anfrage" class="dock-cta"
      ><InkIcon name="diagonal" /><span>Anfragen</span></router-link
    >
  </nav>
</template>
<script setup>
import { ref, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import logo from '@/assets/logo-small.webp';
import InkIcon from '@/components/ui/InkIcon.vue';
import NavigationDrawer from './NavigationDrawer.vue';
const route = useRoute();
const artPage = computed(() => ['/art', '/tierportraets', '/auftragskunst'].includes(route.path));
const menuOpen = ref(false);
const links = [
  { to: '/tattoos', label: 'Tattoos' },
  { to: '/art', label: 'Kunstwerke' },
  { to: '/about-me', label: 'Über mich' },
  { to: '/pets', label: 'Haustiere' },
  { to: '/studio', label: 'Studio' },
];
watch(
  () => route.fullPath,
  () => {
    menuOpen.value = false;
  }
);
</script>
